import { Table } from "@counselpro/counselkit";
import { useState } from "react";
import { useNavigation, useSubmit } from "react-router-dom";

import { Button } from "@/components/clickable";
import { HStack } from "@/components/layout";
import AuthorizeGate from "@/modules/authorize/gate";
import { deleteTableItems, isLoading } from "@/utils";
import { isProjectProcessing } from "@/utils/status/project";
import PROJECTS_TABLE_COLUMNS from "./columns";

export default function ProjectsTable({ projects }) {
  const { state } = useNavigation();
  const submit = useSubmit();
  const [_projects, setProjects] = useState(projects);

  const onDelete = (rowData) => {
    const slugs = rowData.map((item) => item.slug);
    deleteTableItems("slug", slugs, {
      data: _projects,
      setData: setProjects,
    });
    submit({ slugs }, { method: "DELETE", action: "/delete" });
  };

  const isDeleteDisabled = (rowData) => {
    return rowData.find((item) => isProjectProcessing(item));
  };

  return (
    <>
      <HStack className="mb-5 mt-10 w-full justify-between">
        <AuthorizeGate>
          <Button href="/new">Create new project</Button>
        </AuthorizeGate>
      </HStack>

      <Table
        containerClassName="max-h-[650px]"
        loading={isLoading(state)}
        enableFiltering={false}
        enablePagination={false}
        rowData={_projects.items}
        rowSelection="multiple"
        selectionActions={[
          {
            label: "Delete",
            onClick: onDelete,
            disabled: isDeleteDisabled,
          },
        ]}
        columnDefs={PROJECTS_TABLE_COLUMNS}
        suppressRowClickSelection
        domLayout="autoHeight"
      />
    </>
  );
}
